<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
import ProductItem from './product-item'
export default {
    components: {ProductItem},
    data: function () {
        return {
            isLoadingSearch: false,
            productDiscount: 0, productCost: 0,
        }
    },
    computed: {
        serial: {
            get: function() {
                return this.$store.getters['sale/search'];
            },
            set: function(value) {
                this.$store.dispatch("sale/setSearchText", value);        
            }
        },
        
        currentUser: function(){
            return this.$store.getters['auth/currentUser'];
        },
        tabs: function(){
            return this.$store.getters['sale/tabs'];
        },
        currentTab: function(){
            return this.$store.getters['sale/currentTab'];
        },
        sessionID: function(){
            return this.$store.getters['sale/sessionID'];
        },
        posID: function(){
            let posID = this.$store.getters['sale/posID'];
            return typeof posID != 'undefined' && typeof posID.pos_id != 'undefined' ? posID.pos_id : 0;
        },
        district: function(){
            return this.$store.getters['sale/sesdistrictsionID'];
        },
        province: function(){
            return this.$store.getters['sale/province'];
        },
        cashier: function(){
            return this.$store.getters['sale/cashier'];
        },
        paymentMethod: function(){
            return this.$store.getters['sale/paymentMethod'];
        },
        calcProductDiscount: function(){
            let discount = this.productCost * this.productDiscount/100;
            return discount.toLocaleString();
        },
        productSelected: function(){
            return this.$store.getters['sale/productSelected'];
        },
    },
    methods: {
        ...urlMethods,
        formatDiscount(){
            this.productDiscount = parseFloat((this.productDiscount == '' || isNaN(this.productDiscount)) ? 0 : this.productDiscount);
            if(this.productDiscount < 0) this.productDiscount = 0;
            if(this.productDiscount > 100) this.productDiscount = 100;
        },
        setDiscountProduct(e){
            e.preventDefault();
            this.$store.dispatch('sale/updateProductDiscount',this.productDiscount);
            setTimeout(() => {this.$bvModal.hide('modal-discount');}, 100);
            return false;
        },
        searchProduct: async function() {
            if(this.serial.length < 5) return false;
            this.isLoadingSearch = true;
            let that = this;
            try {
                for(const tab of this.tabs){
                    for(const pro of tab.products){
                        if(pro.serials.includes(this.serial)){
                            throw 'Code đã được nhập trong Hoá đơn ' + tab.id;
                        }
                    }
                }
                let res = await this.postUrl({'url' : 'search-product', 'data' : {'code': this.serial, 'posID' : that.posID}});
                if(typeof res == 'undefined' || typeof res.data == 'undefined' || typeof res.error == 'undefined' || typeof res.message == 'undefined'){
                    throw 'Không thế kết nối server';
                }
                if(res.error){
                    throw res.message;
                }
                if(!res.data){
                    throw 'Không tìm thấy sản phẩm';
                }
                this.$store.dispatch("sale/addProduct",res.data);
                this.serial = "";
                this.isLoadingSearch = false;
            } catch (error) {
                console.log(error);
                let text = (typeof error  == 'string' ? error : JSON.stringify(error));
                this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
                this.isLoadingSearch = false;
            }
            setTimeout(() => {that.$refs.serial.focus();}, 100);
        },
    },
    mounted() {
        let that = this;
        setTimeout(() => {
            this.$refs.serial.focus();
        }, 100);
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'modal-discount'){
                this.productDiscount = parseFloat(this.productSelected.discount);
                this.productCost = parseFloat(this.productSelected.cost);
                setTimeout(() => {
                    this.$refs.productDiscount.focus();
                }, 100);
            }
        });
    },
};
</script>

<template>
<div class="list-products-layout">
    <div class="search-box">
        <div class="position-relative">
            <input type="text" ref="serial" class="form-control" :disabled="isLoadingSearch" v-model="serial" placeholder="Nhập serial"  @keyup.enter="searchProduct" />
            <i class="bx bx-search-alt search-icon"></i>
            <div :class="(isLoadingSearch ? 'loading-box-search' : 'loading-box-search hidden')"><i class="fas fa-spinner fa-spin"></i></div>
        </div>
    </div>
    <div class="product-lists">
        <product-item v-for="(item, index) in currentTab.products" :key="index" :item="item"></product-item>        
    </div>
    <b-modal id="modal-discount" title="Giảm giá sản phẩm" title-class="font-18" hide-footer>
        <form class="form-horizontal" @submit="setDiscountProduct" role="form">
            <b-form-group class="mb-3" label-cols-lg="2" label="Giá bán" label-for="product_price" ><b-form-input type="text" disabled for="product_price" :value="productCost | VND"></b-form-input></b-form-group>
            <b-form-group class="mb-3" label-cols-lg="2" label="Phần trăm" label-for="discount_percent" ><b-form-input type="number" ref="productDiscount" autocomplete="off" for="discount_percent" v-on:keyup="formatDiscount" v-model="productDiscount"></b-form-input></b-form-group>
            <b-form-group class="mb-3" label-cols-lg="2" label="Giá giảm" label-for="discount_percent" ><b-form-input type="text" disabled for="discount_percent" :value="calcProductDiscount"></b-form-input></b-form-group>
            <div class="text-right"><b-button type="submit" variant="primary" ><i class="bx bx-check"></i> Xác nhận</b-button></div>
        </form>
    </b-modal>
</div>
</template>
